<template>
  <div>
    <div class="header ">
      <van-row>
        <van-col id="l1" span="5">
          <a href="javascript:void(0);" @click="openRegister" v-if="!$store.state.loginType">
            <p class="header-title red">
              注册
            </p>
          </a>
        </van-col>
        <van-col id="img" span="14">
          <div class="header-img">
            <van-image :src="require('../assets/images/home_logo.png')" width="100%" style="padding-top:5px;" />
          </div>
        </van-col>
        <van-col id="l2" span="5">
          <a href="javascript:void(0);" @click="openLogin" v-if="!$store.state.loginType">
            <p class="header-title red">
              登录
            </p>
          </a>
        </van-col>
      </van-row>
    </div>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" >
      <van-skeleton title avatar :row="4" :loading="loading">
        <van-swipe-item v-for="(item, index) in swiperList" :key="index">
          <van-image width="100%" :src='item.img'>
            <template v-slot:loading>
              <van-loading type="spinner" size="20"/>
            </template>
            <template v-slot:error>加载失败</template>
          </van-image>
        </van-swipe-item>
      </van-skeleton>
    </van-swipe>
    <van-grid :border="false" class="main-grid">
      <van-grid-item>
        <router-link to="/member/agency/agency_link">
          <img src="../assets/images/promotion.png">
          <p>我要推广</p>
        </router-link>
      </van-grid-item>
      <van-grid-item>
        <router-link to="/found_winners" >
          <img src="../assets/images/fxng1.png">
          <p>发现牛股</p>
        </router-link>
      </van-grid-item>
      <van-grid-item>
        <router-link to="/diagnosis_stock" >
          <img src="../assets/images/diagnisis.png">
          <p>免费诊股</p>
        </router-link>
      </van-grid-item>
      <van-grid-item>
        <!-- <router-link to="/channelroom">
         <div class="channel_message_count">
          <img src="../assets/images/gywm1.png">
          <div class="van-info" v-if="unreadMsgCount != 0">{{unreadMsgCount}}</div>
          <span :badge="unread == 0 || !$store.state.loginType ? '' : unread"></span>
          <p>关于我们</p>
         </div> 
        </router-link> -->
        <router-link to="/about_us">
          <img src="../assets/images/gywm1.png">
          <p>关于我们</p>
        </router-link>
      </van-grid-item>
      <!-- <van-grid-item> -->
        <!-- <router-link to=qserver_url> -->
          <!-- <img src="../assets/images/online.png" @click="openQchat()">
          <p>关于我们</p> -->
        <!-- </router-link> -->
      <!-- </van-grid-item> -->
      <!-- <van-grid-item>
        <router-link :to="{name:'AboutUs',query:{activeName:'2'}}">
          <img src="../assets/images/xszy.png">
          <p>新手指引</p>
        </router-link>
      </van-grid-item>
      <van-grid-item>
        <router-link :to="{name:'AboutUs',query:{activeName:'4'}}">
          <img src="../assets/images/jygz.png">
          <p>交易规则</p>
        </router-link>
      </van-grid-item> -->
      <!-- <van-grid-item>
        <a href="http://47.103.121.63/stock_category">
          <img src="../assets/images/5.png">
          <p>智能诊股</p>
        </a>
      </van-grid-item> -->


      <van-grid-item>
        <router-link :to="{name:'CreateCapitalAccounts',query:{activeTab:'1',activeTabSub:'1'}}">
          <img src="../assets/images/atpz.jpeg">
          <p>按天配资</p>
        </router-link>
      </van-grid-item>
            <van-grid-item>
        <router-link :to="{name:'CreateCapitalAccounts',query:{activeTab:'1',activeTabSub:'2'}}">
          <img src="../assets/images/aypz.jpeg">
          <p>按月配资</p>
        </router-link>
      </van-grid-item>
      <!-- <van-grid-item>
        <router-link :to="{name:'CreateCapitalAccounts',query:{activeTab:'1',activeTabSub:'2'}}">
          <img src="../assets/images/azpz.jpeg">
          <p>按月配资</p>
        </router-link>
      </van-grid-item> -->
      <!-- <van-grid-item> -->
        <!-- <router-link :to="{name:'CreateCapitalAccounts',query:{activeTab:'1',activeTabSub:'6'}}">
          <img src="../assets/images/simulate.png">
          <p>免费体验</p>
        </router-link> -->
        <!-- <router-link :to="{name:'CreateCapitalAccounts',query:{activeTab:'1',activeTabSub:'5'}}">
          <img src="../assets/images/simulate.png">
          <p>免费体验</p>
        </router-link>
      </van-grid-item> -->
      <van-grid-item>
        <router-link :to="{name:'CreateCapitalAccounts',query:{activeTab:'1',activeTabSub:'5'}}">
          <img src="../assets/images/simulate_capital.png">
          <p>免费体验</p>
        </router-link>
      </van-grid-item>
      <van-grid-item>
        <router-link to="/activity">
          <img src="../assets/images/hdzq1.png">
          <p>活动专区</p>
        </router-link>
      </van-grid-item>

    </van-grid>


    <div v-on:click="noticeContent(notice)">
      <van-notice-bar scrollable left-icon="volume-o" :text="notice.name" />
    </div>

    <van-image :src="registerGif" width="100%">
      <template v-slot:loading>
        <van-loading type="spinner" size="20"/>
      </template>
      <template v-slot:error>加载失败</template>
    </van-image>
    <van-row gutter="5" class="nav-grid">
      <van-col span="8" v-for="(item,index) in tabmenu" :key="index">
        <p  :class="{active:indexTab===index}" @click="clickTab(index)">
          <pre>{{ item.menu }}</pre>
        </p>
      </van-col>
     <!-- <van-col span="8">
        <p :class="{active:indexTab===2}" @click="clickTab(2)">
          配资交易<br>
          10倍效益
        </p>
      </van-col>
      <van-col span="8">
        <p :class="{active:indexTab===3}" @click="clickTab(3)">
          发现牛股<br>
          价值超10万
        </p>
      </van-col>-->
    </van-row>
    <div class="ad">
      <a href="javascript:void(0);" @click="openFoundWinner">
        <div class="ad-content"  v-for="(item,index) in tabmenu" :key="index" v-if="indexTab===index">
          <h4>{{ item.title }}</h4>
          <pre>{{ item.content }}</pre>
          <div class="register-button">
            <van-button round type="danger" size="small">{{ item.btitle }}</van-button>
          </div>
        </div>
        <!--<div class="ad-content" v-if="indexTab===1">
          <h4>您炒股 他出钱 配资炒股 一键秒完成</h4>
          <p>最高10倍配资 享10倍收益 小本钱做大买卖</p>
          <p>首充送188元-8888元现金 可提现</p>
          <div class="register-button">
            <van-button round type="danger"> 立即注册领钱</van-button>
          </div>
        </div>
        <div class="ad-content" v-if="indexTab===2">
          <h4>券商内部资料免费送 价值10万以上</h4>
          <p>无需炒股经验 直跟券商内幕 风险小利润大</p>
          <p>专业投资分析 预测股票走势 警示潜在风险</p>
          <div class="register-button">
            <van-button round type="danger"> 立即注册领钱</van-button>
          </div>
        </div>-->
      </a>
    </div>
    <!-- ======================================== -->
        <van-row class="rowDesign">
          <van-col v-for="(item,index) in dataArray" :key="index" span="8" class="columnDesign" @click="$router.push({ name: 'Kline', params: { code: item.code } })">
            <van-row class="topValue" style="font-size: 16px"
              ><span style="color:black">{{ item.name }}</span>
            </van-row>
            <div v-bind:class="[item.num >= 0 ? 'redText' : 'greenText']">
            <van-row style="font-size: 14px" class="topValue"
              ><span>{{ item.price }}</span>
            </van-row>
            <van-row style="font-size: 12px" class="topValue"
              ><van-col span="12"><span>{{ item.num }}</span></van-col>
              <van-col span="12"><span>{{ item.inrease }}%</span></van-col>
            </van-row>
            </div>

          </van-col>
        </van-row>
        <van-row style="padding: 10px 0px; border-bottom: 1px solid #ebedf0;">
          <van-col span="12" style="padding-left: 10px;"><span>股市资讯</span></van-col>
          <van-col span="12" style="text-align: right;padding-right: 10px;">
            <router-link to="/news_info"><span style="color:#000000">更多 ></span></router-link>
          </van-col>
      </van-row>
      <div v-for="(item,index) in news" :key="index" @click="goDetails(item.id)">
          <van-row style="padding: 10px 0px; border-bottom: 1px solid #dcdee0;">
              <van-col span="8" style="padding-left: 10px;">
                <img :src="require('../assets/images/login_logo.png')" width="100%" style="width:70px;"/>
                <!-- <img :src="require('../assets/images/'+$store.state.login_logo_img)" style="width:70px;" v-if="!login_register_logo"/> -->
              </van-col>
              <van-col span="16" style="text-align: left;padding-right: 10px;">
                <van-row style="padding-top: 15px;">{{item.title}}</van-row>
                <van-row style="padding: 10px 0px; color: #969799; font-size: 14px;">{{item.time}}</van-row>
              </van-col>
          </van-row>
      </div>
      <!-- ================================== -->
    <div class="footer">
      <div class="footer-content">
        <van-row gutter="10">
          <van-col span="4">
            <!-- <van-image width="100%" :src="app_bottom_img.image_1"/> -->
            <img width="100%" src="../assets/images/360.png"/>
          </van-col>
          <van-col span="4">
            <!-- <van-image width="100%" :src="app_bottom_img.image_2"/> -->
            <img width="100%" src="../assets/images/kx.png"/>
          </van-col>
          <van-col span="4">
            <!-- <van-image width="100%" :src="app_bottom_img.image_3"/> -->
            <img width="100%" src="../assets/images/gx.png"/>
          </van-col>
          <van-col span="4">
            <!-- <van-image width="100%" :src="app_bottom_img.image_4"/> -->
            <img width="100%" src="../assets/images/shui.png"/>
          </van-col>
          <van-col span="4">
            <!-- <van-image width="100%" :src="app_bottom_img.image_5"/> -->
            <img width="100%" src="../assets/images/bdxy.png"/>
          </van-col>
          <van-col span="4">
            <!-- <van-image width="100%" :src="app_bottom_img.image_6"/> -->
            <img width="100%" src="../assets/images/label_sm_90030.png"/>
          </van-col>
        </van-row>
        <p>Copyright © {{ copyright  }}<br> All Rights Reserved（投资有风险，入市需谨慎）</p>
      </div>
      <!--      <div style="height: 50px;width: 100%"></div>-->
    </div>
    <van-popup v-model="popupStatus" closeable style="width: 90%;">
      <div class="popupContent" v-html="popup.content" style="padding:10px">

      </div>
    </van-popup>
  <transition name="van-slide-up">
    <div class="app-promotion" v-show="promotion">
      <div class="promotion-wrapper">
        <van-row>
          <van-col span="5">
            <div class="promotion-icon">
              <img src="../assets/images/logo.png">
            </div>
          </van-col>
          <van-col span="13">
            <div style="color: white">
              <p class="promotion-content">
                安全配资 上易博优配<br>
                <span class="red">知名品牌券商</span>
              </p>
            </div>
          </van-col>
          <van-col span="4">
            <div class="promotion-download">
              <van-button size="mini" type="danger" @click="openDownload">
                APP下载
              </van-button>
            </div>
          </van-col>
          <van-col span="1">
            <a href="javascript:void(0);" @click="closePromotion">
              <van-icon name="close" color="white"/>
            </a>
          </van-col>
        </van-row>
      </div>
    </div>
  </transition>
  
  <van-dialog v-model="qrPopup" :title="popupContent" showConfirmButton>
    <div class="img-box">
      <center>  <div id="downloadQrCodeSecond"></div> </center>
    </div>
  </van-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import { Toast } from "vant";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import QRCode from "qrcodejs2";

// import Vue from 'vue';
// import VueQRCodeComponent from 'vue-qrcode-component';
// Vue.component('qr-code', VueQRCodeComponent);

export default {
  name: "Home",
  props: ["copyright"],
  data() {
    return {
      unreadMsgCount:"",
      swiperList: [],
      dataArray: [],
      topArray: ["sh000001", "sz399001", "sz399006"],
      news: [],
      loading: true,
      notice: {
        name: "",
        content: "",
        time: "",
      },
      indexTab: 1,
      registerGif: "",
      tabmenu: [],
      codes: [],
      popupStatus: false,
      popup: {
        content: "",
        popup_status: "0",
      },
      home_logo: "",
      login_register_logo: "",
      qserver_url: "",
      app_bottom_img: "",
      appDownload: "",
      testFlightDownload: "",
      androidPro: "",
      appleFreeUpgrade: "",
      androidFreeUpgrade: "",
      nativeApp: "",
      qrPopup: false,
      popupContent: "",
      qrCode: null,
      pc_mac: "",
      pc_windows: "",
      hk_android: "",
      hk_apple: "",
      hk_apple_tf: "",
    };
  },
  computed: {
    promotion: function () {
      return this.$store.state.promotion;
    },
    unread: function (val) {
      var c = 0;
      this.$store.state.channel_list.forEach((element) => {
        c += element.unread;
      });
      this.unreadMsgCount = c;
    },
  },
  methods: {
    showPopup(operate) {
      switch (operate) {
        case "testflight":
          this.qrPopup = true;
          this.popupContent = "苹果防闪退版";
          setTimeout(() => {
            this.QrCode(this.testFlightDownload);
          }, 300);
          break;
        case "vueandrod":
          this.qrPopup = true;
          this.popupContent = "安卓专业版";
          setTimeout(() => {
            this.QrCode(this.androidPro);
          }, 300);
          break;
        case "applefree":
          this.qrPopup = true;
          this.popupContent = "苹果免升级版";
          setTimeout(() => {
            this.QrCode(this.appleFreeUpgrade);
          }, 300);
          break;
        case "androidfree":
          this.qrPopup = true;
          this.popupContent = "安卓免升级版";
          setTimeout(() => {
            this.QrCode(this.androidFreeUpgrade);
          }, 300);
          break;
        case "nativeapp_android":
          this.qrPopup = true;
          this.popupContent = "安卓经典版";
          setTimeout(() => {
            this.QrCode(this.nativeApp);
          }, 300);
          break;
        case "nativeapp_ios":
          this.qrPopup = true;
          this.popupContent = "苹果经典版";
          setTimeout(() => {
            this.QrCode(this.nativeApp);
          }, 300);
          break;
        case "hkandroid":
          this.qrPopup = true;
          this.popupContent = "易博港股安卓版";
          setTimeout(() => {
            this.QrCode(this.hk_android);
          }, 300);
          break;
        case "hkapple":
          this.qrPopup = true;
          this.popupContent = "易博港股苹果版";
          setTimeout(() => {
            this.QrCode(this.hk_apple);
          }, 300);
          break;
        case "hkappletf":
          this.qrPopup = true;
          this.popupContent = "易博港股苹果TF";
          setTimeout(() => {
            this.QrCode(this.hk_apple_tf);
          }, 300);
          break;
        case "mac":
          this.qrPopup = false;
          this.popupContent = "MAC桌面端";
          window.open(this.pc_mac)
          break;
        case "windows":
          this.qrPopup = false;
          this.popupContent = "Windows桌面端";
          window.open(this.pc_windows)
          break;

        default:
          break;
      }
    },
    QrCode(url) {
      if (this.qrCode) {
        this.qrCode.makeCode(url);
      } else {
        this.qrCode = new QRCode("downloadQrCodeSecond", {
          width: 200,
          height: 200,
          text: url, // 二维码地址
        });
      }
    },
    openQchat() {
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url });
      } else {
        window.open(this.$store.state.chat_server_url);
      }
      // if (Capacitor.getPlatform() === "android") {
      //   //check if android app, if android app use native plugin to open popup
      //   Browser.open({ url: this.qserver_url });
      // } else {
      //   window.open(this.qserver_url);
      // }
    },
    openDownload() {
      this.$emit("openDownload");
    },
    get_qchat_server_url() {
      let that = this;
      // that
      //   .$http({
      //     url: "/",
      //     method: "post",
      //     data: {
      //       nozzle: "server_url",
      //     },
      //   })
      //   .then(function (res) {
      //     if (res.data.code == 1) {
      //       var data = res.data.data;
      //       that.qserver_url = data;
            that.$store.commit("chatServerUrl", "");
        //   } else if (res.data.code == 0) {
        //     that.$toast.fail(res.data.msg);
        //   }
        // });
    },
    home() {
      let that = this;
      var l = document.getElementById("l1");
      var l1 = document.getElementById("l2");
      var img = document.getElementById("img");
      if (that.$store.state.loginType) {
        l.style.display = "none";
        l1.style.display = "none";
        img.style.marginLeft = "80px";
      }
    },
    get_logo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "logo",
            logo_name: "home_logo,login_register_logo",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.home_logo = resData.data.home_logo;
            that.login_register_logo = resData.data.login_register_logo;

            that.$store.commit("HomeLogoUrl", that.home_logo); // store.js
            that.$store.commit("LoginLogoUrl", that.login_register_logo); // store.js
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    getInfoData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "home",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code === 1) {
            that.swiperList = resData.data.banner;
            that.notice = resData.data.notice;
            that.loading = false;
            that.registerGif = resData.data.appgif;
            that.tabmenu = resData.data.tabmenu;
            that.news = resData.data.news;
            that.app_bottom_img = resData.data.app_bottom_img;
            localStorage.setItem(
              "encript_public_key",
              resData.data.encript_public_key
            );
            if (resData.data.popup.popup_status == 1) {
              that.popupStatus = true;
              that.popup = resData.data.popup;
            } else {
              that.popupStatus = false;
            }
          } else if (resData.code === 0) {
            that.$notify({ type: "warning", message: resData.msg });
          }
        })
        .catch(() => {
          that.loading = false;
          Toast.fail(that.$NoNetworkErrorMsg);
        });
    },
    clickTab(index) {
      let that = this;
      that.indexTab = index;
    },
    closePromotion() {
      this.$store.commit("changePromotion", false);
    },
    openSignIn() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$toast({
          message: "您还未登录",
          type: "fail",
          onClose: function () {
            that.$router.push("/login");
          },
        });
      } else {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "checkin",
              token: sessionStorage.getItem("token"),
            },
          })
          .then(function (res) {
            let resData = res.data;
            if (res.data.code === 1) {
              that.$toast.success(resData.msg);
            } else if (res.data.code === 0 || res.data.code === -1) {
              that.$toast.fail(resData.msg);
            }
          });
      }
    },
    openAgency() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$toast({
          message: "您还未登录",
          type: "fail",
          onClose: function () {
            that.$router.push("/login");
          },
        });
      } else {
        that.$router.push("/member/agency");
      }
    },
    openFoundWinner() {
      let that = this;
        that.$router.push("/found_winners");
    },
    openRegister() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/registered");
      } else {
        that.$router.push("/member/members");
      }
    },
    openLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      } else {
        that.$router.push("/member/members");
      }
    },
    getData() {
      let that = this;
      $.ajax({
        url: "https://sqt.gtimg.cn/utf8/?q=" + that.topArray.toString(),
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          var i, elements;
          var array = [];
          for (i = 0; i < that.topArray.length; i++) {
            elements = eval("v_" + that.topArray[i]).split("~");
            var elementNames = {};
            elementNames.price = elements[3];
            elementNames.inrease = elements[32];
            elementNames.num = elements[31];
            elementNames.name = elements[1];
            elementNames.id = elements[0];
            elementNames.code = that.topArray[i];
            array.push(elementNames);
          }
          that.dataArray = array;
        },
      });
    },
    noticeContent(notice) {
      this.$store.state.home_notice_content = notice.content;
      this.$router.push({
        path: "/notice_detailed",
      });
    },
    goDetails(nid) {
      window.sessionStorage.setItem("nid", nid);
      this.$router.push({
        path: "/news_info_detailed",
      });
    },
    getQRLink() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            action: "download_link",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            // that.QrCodeSecond(res.data.data);
            that.testFlightDownload = res.data.data.iOS_testflight;
            that.androidPro = res.data.data.android_pro;
            that.appleFreeUpgrade = res.data.data.apple_free_upgrade;
            that.androidFreeUpgrade = res.data.data.android_free_upgrade;
            that.nativeApp = res.data.data.app_app;
            that.pc_mac = res.data.data.pc_mac;
            that.pc_windows = res.data.data.pc_windows;
            that.hk_android = res.data.data.hk_android;
            that.hk_apple = res.data.data.hk_apple;
            that.hk_apple_tf = res.data.data.hk_apple_tf;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
  },
  mounted: function () {
    this.getInfoData();
    this.getData();
    // this.get_logo();
    this.get_qchat_server_url();
    this.getQRLink();
    let code = this.$route.query.code;
    if (code) {
      window.sessionStorage.setItem("rePhone", code);
    }
  },
};
</script>


<style scoped>

.channel_message_count{
  position: relative;
  display: inline-block;
}
.app-promotion {
  position: fixed;
  bottom: 50px;
  left: 0;
  z-index: 9999;
  height: 70px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}

.promotion-wrapper {
  width: 90%;
  height: 100%;
  margin: 0 auto;
}

.promotion-icon {
  width: 100%;
  height: 70px;
  position: relative;
}

.promotion-icon img {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.promotion-download {
  line-height: 70px;
}

.ad {
  width: 95%;
  margin: 10px auto;
  border: 1px solid #ff3334;
}

.ad-content {
  padding: 10px 0;
  margin: 5px 0;
}

.ad-content h4 {
  text-align: center;
  margin: auto;
  color: red;
  border-bottom: 1px solid red;
  width: 80%;
  font-size: 14px;
}

.ad-content pre {
  text-align: center;
  font-size: 12px;
  margin: 10px 0;
  color: black;
}

.main-grid {
  text-align: center;
}

.main-grid img {
  width: 50px;
  height: 50px;
}

.main-grid p {
  font-size: 13px;
  color: #606060;
  line-height: 1.5;
  margin: 0;
}

.nav-grid {
  width: 95%;
  margin: 0 auto;
}

.nav-grid p {
  text-align: center;
  border: 1px solid #ff3334;
  border-radius: 5px;
  margin: 0;
}

.active {
  background: #ff3334;
  color: white !important;
}

.red {
  color: red;
}

.promotion-content {
  font-size: 14px;
  font-weight: bold;
}

.download {
  border: 1px solid #cccccc;
}

.downloadTitle {
  text-align: center;
}

.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.header {
  width: 100%;
  height: 40px;
  background: #ffffff;
  overflow: hidden;
}

.header-title {
  text-align: center;
  line-height: 40px;
  margin: 0;
  font-weight: bold;
}

.header-img {
  text-align: center;
  margin: 0 auto;
  width: 65%;
  height: 40px;
}
.register-button {
  text-align: center;
  margin-top: 5px;
}
.footer {
  width: 100%;
  background: #f3f2f2;
  overflow: hidden;
}
.footer-content {
  width: 95%;
  margin: 10px auto;
}
.footer-content p {
  margin: 5px 0;
  font-size: 12px;
  text-align: center;
}
.popupContent >>> img {
  width: 100%;
}
.popupContent >>> p {
  margin: 0;
}

.rowDesign {
  text-align: center;
  line-height: 10px;
  padding-top: 5px;
}

.columnDesign {
  height: 82px;
  line-height: 82px;
  background: #ffffff;
  border-right: 1px solid #ebedf0;
}

.topValue {
  text-align: center;
  line-height: 10px;
  padding-top: 14px;
}
.redText {
  color: red;
}
.greenText {
  color: green;
}

.contentBg {
  background: url("../assets/images/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* padding: 500px 15px 40px; */
}

.progress {
  text-align: center;
  padding: 200px 0px 150px 0px;  /* SET TOP AND BOTTOM  */
}

</style>

<style>
#dialogStyle .el-dialog__body {
  padding: 25px 25px 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue